import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "CustomerStatistics" }
const _hoisted_2 = { style: {"align-items":"center","display":"inline-flex","margin":"0 auto"} }
const _hoisted_3 = { style: {"margin-left":"10px"} }

import {searchFormConfig} from '@/views/main/wechatMgmt/customerStatistics/config/search.config'
import {contentTableConfig} from '@/views/main/wechatMgmt/customerStatistics/config/content.config'
import {usePageSearch} from '@/hooks/userPageSearch'
import {getListData} from "@/service/main/system";
import {useStore} from "@/store";
import {initEmptyParam} from "@/hooks/useInitParam";
import {ref} from "vue";
import { modalConfig } from '@/views/main/wechatMgmt/customerChannelStatistics/config/modal.config'
import { ElMessage } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerStatistics',
  setup(__props) {

initEmptyParam()
const store = useStore()

const getCompanyList = async () => {
  let roleData = await getListData('/main/enterpriseWechat/config/listAll', {})
  const roleItem = searchFormConfig.formItems.find((item) => item.field === 'corpId')
  roleItem!.options = roleData.map((item: any) => {
    return {title: item.name, value: item.id}
  })
}
getCompanyList()

const getUsedBy = async () => {
  let userList = await getListData('/main/enterpriseWechat/dingUser/listAll', {});
  const userOptions = userList.map((item: any) => {
    return {title: item.userName, value: item.userName};
  })
  const usedByItem = searchFormConfig.formItems.find(item => item.field === 'usedBy');
  usedByItem!.options = userOptions;
}
getUsedBy()

const getThirdPartyList = async () => {
  let thirdPartyData = await getListData('/main/customerChannel/queryThirdParty', {})
  const thirdPartyItem = searchFormConfig.formItems.find((item) => item.field === 'thirdParty')
  thirdPartyItem!.options = thirdPartyData.map((item: any) => {
    return {title: item, value: item}
  })
  const thirdPartyModal = modalConfig.formItems.find(item => item.field === 'thirdParty')
  thirdPartyModal!.options = thirdPartyData.map((item: any) => {
    return {title: item, value: item}
  })
}
getThirdPartyList()

const handleSortChange = (value: any) => {
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

let queryParam = ref()
if (store.state.login.userInfo.isManager != '1') {
  queryParam.value = {
    usedBy: store.state.login.userInfo.realName
  }
} else {
  queryParam.value = {}
}

store.commit('system/changeQueyryInfo', queryParam.value)

const resetCb = () => {
  if (store.state.login.userInfo.isManager != '1') {
    return {
      usedBy: store.state.login.userInfo.realName
    }
  } else {
    return {}
  }
}

const validateSearchParams = (params: any): boolean => {
  const hasFilter = Object.keys(params).some(key => {
    const value = params[key]
    if (Array.isArray(value)) {
      return value.length > 0 && value.some(v => v !== null && v !== undefined && v !== '')
    }
    return value !== null && value !== undefined && value !== ''
  })

  if (!hasFilter) {
    ElMessage.warning('请至少选择一个筛选条件后再查询')
    return false
  }
  return true
}

const handleSearchClick = (formdata: any) => {
  const params = { ...formdata }

  if (!validateSearchParams(params)) {
    return
  }

  pageContentRef.value?.getPageData(params)
}

const [pageContentRef, handleResetClick, , handleDownBtnClick] = usePageSearch(resetCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: handleSearchClick
    }, null, 8, ["searchFormConfig", "onResetBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "customerStatistics",
      downFilename: "客户统计.xlsx",
      onSortChange: handleSortChange,
      onDownBtnClick: _unref(handleDownBtnClick)
    }, {
      consumer: _withCtx((scope) => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_avatar, {
            shape: "square",
            size: 30,
            src: scope.row.avatar
          }, null, 8, ["src"]),
          _createElementVNode("span", _hoisted_3, _toDisplayString(scope.row.uname) + " (" + _toDisplayString(scope.row.remark) + ") ", 1)
        ])
      ]),
      isRepeat: _withCtx((scope) => [
        _createVNode(_component_el_tag, {
          type: scope.row.isRepeat == 1 ? 'danger' : 'info',
          effect: scope.row.isRepeat == 1 ? 'dark' : 'plain',
          size: "small"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(scope.row.isRepeat == 1 ? '重复客户' : '非重复'), 1)
          ]),
          _: 2
        }, 1032, ["type", "effect"])
      ]),
      isRepeatWithinSixMonth: _withCtx((scope) => [
        _createVNode(_component_el_tag, {
          type: scope.row.isRepeatWithinSixMonth == 1 ? 'danger' : 'info',
          effect: scope.row.isRepeatWithinSixMonth == 1 ? 'dark' : 'plain',
          size: "small"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(scope.row.isRepeatWithinSixMonth == 1 ? '是' : '否'), 1)
          ]),
          _: 2
        }, 1032, ["type", "effect"])
      ]),
      isDeletedWithin24Hours: _withCtx((scope) => [
        _createVNode(_component_el_tag, {
          type: scope.row.isDeletedWithin24Hours == 1 ? 'danger' : 'info',
          effect: scope.row.isDeletedWithin24Hours == 1 ? 'dark' : 'plain',
          size: "small"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(scope.row.isDeletedWithin24Hours == 1 ? '是' : '否'), 1)
          ]),
          _: 2
        }, 1032, ["type", "effect"])
      ]),
      isInAfterSales: _withCtx((scope) => [
        _createVNode(_component_el_tag, {
          type: scope.row.isInAfterSales == 1 ? 'success' : 'info',
          effect: scope.row.isInAfterSales == 1 ? 'dark' : 'plain',
          size: "small"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(scope.row.isInAfterSales == 1 ? '是' : '否'), 1)
          ]),
          _: 2
        }, 1032, ["type", "effect"])
      ]),
      remarkTags: _withCtx((scope) => [
        _createElementVNode("span", null, _toDisplayString(_ctx.getRemarkTagText(scope.row.remark)), 1)
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onDownBtnClick"])
  ]))
}
}

})